import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { fromJS } from 'immutable';
import { withStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { IconButton, Tooltip } from '@mui/material';
import { FileDownloadOutlined, OpenInNew, PostAdd } from '@mui/icons-material';

import AudioPlayer from '../../../../Calls/AudioPlayer';
import { displayDocument } from '../../../../../utils/windowOpenFunction';
import { formatTextToHTML } from '../../../constant';
import {
  addPhotoToInterOrDevis, artisanInterListDialog
} from '../../../../../actions/conversations';
import collections from '../../../../../constants/collections';
import MessageDocument from './MessageDocument';

const styles = {
  mms: {
    borderRadius: 5,
  },
  link: {
    textDecoration: 'none',
    cursor: 'pointer'
  },
  audio: {
    minWidth: 350
  },
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

const formatUrlInText = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return formatTextToHTML(text).replace(urlRegex, (url) =>
    `<a target="_blank" href="${url}">${url}</a>`);
};

const getDocument = (message) => {
  if (message.get('urlFile') && message.get('urlFile').size) {
    return message.get('urlFile');
  }
  const link = message.get('document') || message.get('path') || '';
  return link && fromJS([{
    link: link || '',
    type: link.includes('base64') ?
      ((link.split(';')[0] || '').split('/') || [])[1] : '',
    text: message.get('text') || ''
  }]);
};

const DocumentContainer = ({
  artisan, text, link, type, children, user, dataObject, collection
}) => {
  const [fileAdded, setFileAdded] = useState(false);
  let downloadLink = type ? link : '';
  if (link.includes('dropbox')) {
    downloadLink = link.replace('dl=0', '');
    downloadLink = `${downloadLink}&dl=1`;
  }
  return <Box display="flex" alignItems="center">
    <div>{children}</div>
    <Box display='flex' flexDirection='column'>
      {downloadLink ? <IconButton component='a'
        {...(type ? { download:
          text.includes(`.${type}`) ? text : `file.${type}` } : {})}
        target={!downloadLink.includes('dropbox') ? '_blank' : ''}
        href={downloadLink}>
        <FileDownloadOutlined />
      </IconButton> : ''}
      <IconButton onClick={() => displayDocument(link,
        link.includes('base64'),
        link.includes('http'))}>
        <OpenInNew />
      </IconButton>
      {(artisan || dataObject._id) &&
      link.includes('dropbox') ? <Tooltip title={artisan ?
          'Ajouter a un OS' :
          `Ajouter ${collection === 'devis' ? 'au devis' : 'à l\'OS'}`}>
          <IconButton color={artisan ? 'primary' : 'secondary'}
            disabled={fileAdded}
            onClick={() =>
              artisan ?
                artisanInterListDialog({ fileLink: link, artisan, user })
                : addPhotoToInterOrDevis({
                  fileLink: link, user,
                  docId: dataObject._id,
                  collection: collection === 'intervention' ?
                    collections.interventions : collections.devis,
                  dropbox: dataObject.dropbox
                }).then((added) => setFileAdded(!!added))
            }>
            <PostAdd />
          </IconButton>
        </Tooltip> : null}
    </Box>
  </Box>;
};

const displayMessage = ({
  classes, message, user, dataObject, type: collection
}) => {
  const documents = getDocument(message);
  const messageType = [
    {
      messageCondition: !message.get('audio') && !!documents && documents.size,
      component: [
        message.get('text') ?
          <>
            {message
              .get('text')
              .split(/\n/g)
              .map((e) => (
                <Typography
                  className={classes.senderName}
                  variant="body1"
                  noWrap
                  key={typeof e === 'string' ? e.slice(0, 10) : e}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(formatUrlInText(e))
                  }}
                />
              ))}
          </> : '',
        ...(documents ? documents.map((e) => {
          if (!e.get('link')) {
            return (
              <Box
                key={`missing-${e.get('fileName') || e.get('text') || e.hashCode()}`}
                display="flex"
                alignItems="center"
                p={1}
              >
                <Typography variant="caption" color="error">
                  {`Document non disponible${e.get('fileName') ? ` : ${e.get('fileName')}` : ''}`}
                </Typography>
              </Box>
            );
          }
          return (
            <DocumentContainer key={`${e.get('text')}-${e.get('link')}`}
              artisan={message.get('artisan')}
              text={e.get('text')}
              type={e.get('type')}
              link={e.get('link')}
              collection={collection}
              user={user}
              dataObject={dataObject}>
              <MessageDocument link={e.get('link')} />
            </DocumentContainer>
          );
        }) : [])]
    },
    {
      messageCondition:
        message.get('text') && (!documents || !documents.size),
      component:
        message.get('text') && message
          .get('text')
          .split(/\n/g)
          .map((e) => (
            <Typography
              className={classes.senderName}
              variant="body1"
              noWrap
              key={typeof e === 'string' ? e.slice(0, 10) : e}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(formatUrlInText(e || '&nbsp;'))
              }}
            />
          ))
    },
    {
      messageCondition:
        !!message.get('audio'),
      component:
        <div className={classes.audio} key='audio'>
          <AudioPlayer noPadding url={message.get('audio')}/>
        </div>,
    }
  ];
  return messageType.filter((e) => e.messageCondition);
};

const ChatMessage = (props) => {
  const generateMessageContent = displayMessage(props);
  return (
    <Box position="relative">
      {generateMessageContent &&
            generateMessageContent.map(e => e.component)}
    </Box>
  );
};

export default withStyles(ChatMessage, styles);
